import { BlocksContent } from "@strapi/blocks-react-renderer";
import { PromoCampaign } from "providers/CampaignProvider";

import { AllPromoContentTypesProps } from "components/PromoCampaigns/promoContent/types";
import { StrapiLocale } from "constants/enum";

import { Enum_Promocampaign_Theme } from "./generated/graphql";

export enum PromoContentType {
    RUNNING_LINE = "promo-content.running-line",
    COUNTDOWN = "promo-content.countdown",
}

export type BaseCMSContentProps<T> = T & {
    __typename: string;
};

export type CMSPromoContentProps =
    BaseCMSContentProps<AllPromoContentTypesProps>;

export interface CMSPromoCampaignPagesFilter {
    slug: string;
    locale: StrapiLocale;
}
export interface CMSPromoCampaign {
    documentId: string;
    name: string;
    title: string;
    locale: StrapiLocale;
    firstDay: string;
    lastDay: string;
    campaignLink?: {
        href: string;
        locale: StrapiLocale;
    };
    excludedPages: CMSPromoCampaignPagesFilter[];
    includedPages: CMSPromoCampaignPagesFilter[];
    disclaimer: BlocksContent;
    theme: Enum_Promocampaign_Theme;
    content: {
        selected: CMSPromoContentProps[];
    };
}
export interface CmsPromoCampaignsWrapperProps {
    data: PromoCampaign[];
}
